module.exports = __webpack_public_path__ + "img/Button_AutoSpin.a7afe492.png";